import { constants } from "assets/constants";
import { Helmet } from "react-helmet";
import css from "./Home.module.scss";
import SecFive from "./SecFive/SecFive";
import SecFour from "./SecFour/SecFour";
import SecOne from "./SecOne/SecOne";
import SecSeven from "./SecSeven/SecSeven";
import SecSix from "./SecSix/SecSix";
import SecThree from "./SecThree/SecThree";
import SecTwo from "./SecTwo/SecTwo";

const Home = () => {
    return (
        <div className={css.home}>
            <Helmet>
                <title>{constants.titles.home}</title>
                <meta name="description" content={constants.descriptions.home} />
            </Helmet>
            <SecOne />
            <SecTwo />
            <SecThree />
            <SecFour />
            <SecFive />
            <SecSix />
            <SecSeven />
        </div>
    );
};

export default Home;
